{
  "INVENTORY_UI": {
    "COMMON": {
      "ACTIONS": {
        "ADD_ITEMS": "Add items",
        "ADD_TO_ORDER": "Add to order",
        "CANCEL": "Cancel",
        "CLEAR": "Clear",
        "REMOVE": "Remove",
        "SELECT": "Select",
        "SAVE": "Save"
      },
      "ITEM_TYPE": {
        "PRODUCT": "Product",
        "PRODUCTS": "Products",
        "SERVICE": "Service",
        "SERVICES": "Services",
        "PACKAGE": "Package",
        "PACKAGES": "Packages",
        "ALL_ITEMS": "All items"
      },
      "UNAVAILABLE_ITEM": {
        "SUSPENDED": {
          "SUBTEXT": "Unavailable",
          "TOOLTIP": "This item has been suspended, and is no longer available for new orders"
        },
        "COUNTRY_RESTRICTION": {
          "SUBTEXT": "Unavailable in {{country}}",
          "TOOLTIP": "Unavailable to customers located in {{country}}",
          "COUNTRY_FALLBACK": "your country"
        },
        "ALREADY_ACTIVE": {
          "SUBTEXT": "Already active",
          "TOOLTIP": "This item is already active"
        },
        "DEFAULT": {
          "SUBTEXT": "Unavailable",
          "TOOLTIP": "This item is not available"
        }
      }
    },
    "ACTIVE_ITEMS": {
      "TITLE": "Active items",
      "NO_ACTIVE_ITEMS": "No active items",
      "STATUS": {
        "ACTIVE": "Active",
        "CANCELED": "Canceled",
        "PENDING": "Pending",
        "DEMO": "Demo",
        "DEMO_EXPIRED": "Demo expired"
      }
    },
    "ITEM_SELECTOR": {
      "SHOW_UNAVAILABLE": "Show unavailable",
      "SHOW_ADDONS": "Show add-ons",
      "COLUMN": {
        "NAME": "Name",
        "QUANTITY": "Quantity",
        "WHOLESALE": "Wholesale",
        "RETAIL": "Retail"
      },
      "REQUIRED_ITEMS_LABEL": "Required items to be active",
      "ITEM_TYPE_BY_OWNER": "{{itemType}} by {{owner}}",
      "CONFLICT_RESOLUTION_MODAL": {
        "TITLE": "Add to order?",
        "MESSAGE": "One or more products in this package are already selected or active. Add the remaining products to this order?"
      },
      "DEPENDENCIES": {
        "SELECTION_NOTIFICATION": "{{itemNames}} selected as well",
        "REMOVAL_NOTIFICATION": "{{itemNames}} removed as well",
        "REMOVAL_DUE_TO_EDITION_CHANGE": "{{affectedItemNames}} removed because required edition of {{triggerItemName}} changed",
        "REQUIRED_ITEMS_UNAVAILABLE": "Missing required items — Contact an administrator to ensure that all requirements are available for this item"
      },
      "VIEW_ADDONS": "View add-ons"
    },
    "ITEM_SEARCH_SELECT_FILTER": {
      "LABEL": "Select item",
      "ADDON_LABEL": "Select add-on",
      "PRODUCT_LABEL": "Select product",
      "SEARCH": "Search"
    },
    "ITEM_SELECTION_CART": {
      "TITLE": "Selected items",
      "NO_ITEMS_SELECTED": "No item selected",
      "CLEAR_ALL_CONFIRMATION_MODAL": {
        "TITLE": "Clear selected items?",
        "MESSAGE": "This action cannot be undone."
      },
      "REMOVE_ITEM_CONFIRMATION_MODAL": {
        "TITLE": "Remove item?",
        "MESSAGE": "This will also remove the {{parentItemName}} package from this order. The rest of its contents will stay on this order, but this may change the total retail price of the order."
      }
    },
    "ITEM_PRICING_TABLE": {
      "COLUMNS": {
        "ITEM": "Item",
        "QUANTITY": "Quantity",
        "WHOLESALE": "Wholesale",
        "RETAIL": "Retail",
        "FREQUENCY": "Frequency",
        "RETAIL_TOTAL": "Retail total"
      },
      "ACTION_MENU": {
        "ADD_SETUP_FEE": "Add setup fee",
        "RESET_TO_DEFAULT": "Reset to default",
        "REMOVE_ITEM": "Remove item",
        "EDIT_BILLING_TERMS": "Edit billing terms",
        "ADD_BILLING_TERMS": "Add billing terms",
        "EDIT_BILLING_FREQUENCY": "Edit retail billing frequency"
      },
      "FOOTER": {
        "TOTALS": "Totals",
        "WHOLESALE": "Wholesale",
        "RETAIL": "Retail"
      },
      "ORIGINAL_PRICE_HINT": "Original price: ",
      "AUTOMATICALLY_RENEW": "Automatically renews"
    },
    "BILLING_FREQUENCY": {
      "ONE_TIME": "One time",
      "MONTHLY": "Monthly",
      "YEARLY": "Yearly"
    },
    "EDIT_BILLING_TERMS_DIALOG": {
      "TITLE": "Edit billing terms",
      "FORM": {
        "START_DATE": "Start date",
        "ESTIMATED_END_DATE": "Estimated end date: {{estimatedEndDate}}",
        "NOT_APPLICABLE": "N/A",
        "TERM_LENGTH": "Term length",
        "BILLING_TERMS": "Billing terms",
        "FIXED_TERM": "Fixed number of payments",
        "INDEFINITE_TERM": "Automatically renew until cancelled",
        "BILLING_FREQUENCY_ONE_TIME": "one-time",
        "BILLING_FREQUENCY_MONTH": "month",
        "BILLING_FREQUENCY_MONTHS": "months",
        "BILLING_FREQUENCY_YEAR": "year",
        "BILLING_FREQUENCY_YEARS": "years",
        "INCLUDE_IN_INVOICES": "Include in invoices",
        "INCLUDE_IN_INVOICES_HINT": "When turned off, the subscription created for this item will not be included in invoices"
      }
    },
    "BILLING_PERIOD": {
      "START_DATE_ONE_MONTH": "{{startDate}} (1 month)",
      "START_DATE_MANY_MONTHS": "{{startDate}} ({{numPeriods}} months)",
      "START_DATE_ONE_YEAR": "{{startDate}} (1 year)",
      "START_DATE_MANY_YEARS": "{{startDate}} ({{numPeriods}} years)",
      "ONE_MONTH": "1 month",
      "MANY_MONTHS": "{{numPeriods}} months",
      "ONE_YEAR": "1 year",
      "MANY_YEARS": "{{numPeriods}} years",
      "SAVE_AND_ADD_ANOTHER_TERM": "Save and add another term"
    },
    "EDIT_RETAIL_BILLING_FREQUENCY_DIALOG": {
      "TITLE": "Edit retail billing frequency",
      "RETAIL_BILLING_FREQUENCY": "Retail billing frequency"
    }
  }
}
